<template>
<div class="vh-desc">{{ $t('lang.k_178001') }}</div>
</template>
<script>

export default {};
</script>
<style lang="less" scoped>
  .vh-desc {
    line-height: 24px;
    text-indent: 2em;
    color: #1a1a1a;
  }
</style>
